export const FREESWITCH_ADDRESS_KEY = 'P-SVRS-FS-ADDR';
